import React, {useState} from "react";
import Tab, {TabGroup} from "@amzn/meridian/tab";
import Column from "@amzn/meridian/column";
import Heading from "@amzn/meridian/heading"
import Row from "@amzn/meridian/row";
import AssociatePackageHistory from "./AssociatePackageHistory";
import AssociateContainerHistory from "./AssociateContainerHistory";
import {generateBreadCrumb} from "../BreadCrumbsUtils";
import {FormattedMessage} from "react-intl";
import RefreshTimer from "../../../commons/RefreshTimer";
import IncidentReportView from "./IncidentReportView";
import {useEffect} from "react";
import {isSafetyReportFeatureEnabled} from "../../../handler/ParentDataHandler";

export const AssociateDetailsView = (props) => {
    const [currentTab, setCurrentTab] = useState("Package");
    const [updated, setUpdated] = useState(null);
    const [isSafetyReport, setIsSafetyReport] = useState(false);

    useEffect(() => {
        try {
            isSafetyReportFeatureEnabled().then(res => {
                setIsSafetyReport((res.isSafetyReportEnabled.trim().toLowerCase().replace(/\W/g, "") === "true" ? true : false));
            }, [isSafetyReport])
        } catch (error) {
            console.log("Error getting value for safety report feature")
        }

    });

    var startDate = props.startDate ? 'from ' + new Date(props.startDate - (new Date().getTimezoneOffset() * 60 * 1000)).toISOString().substr(0, 10) : '';
    var endDate = props.endDate ? 'to ' + new Date(props.endDate - (new Date().getTimezoneOffset() * 60 * 1000) - (60 * 60 * 24 * 1000)).toISOString().substr(0, 10) : '';

    return (
        <div>
            <Column widths={["grid-5"]} spacingInset="large">
                {
                    generateBreadCrumb(props.previousPath, "Associate Detail")
                }
                <Row spacingInset="none none medium">
                    <Heading level={2}><FormattedMessage id="search.associate.detail.headerPrefix" defaultMessage="Events for " />{props.associateLoginId} {startDate} {endDate}</Heading>
                </Row>
                <RefreshTimer deps={[updated]} />
                <TabGroup value={currentTab} onChange={setCurrentTab}>
                    <Tab value="Package"><FormattedMessage id="search.associate.detail_package" defaultMessage="Package" /></Tab>
                    <Tab value="Container"><FormattedMessage id="search.associate.detail_container" defaultMessage="Container" /></Tab>
                    {isSafetyReport === true ?
                        <Tab value="Statistics"><FormattedMessage id="search.associate.detail_statistics_view" defaultMessage="Statistics" /></Tab>
                        : null}
                </TabGroup>
                {currentTab === "Package" ? <AssociatePackageHistory setUpdated={setUpdated} previousPath={props.previousPath} associateLoginId={props.associateLoginId} startDate={props.startDate} endDate={props.endDate} /> :
                    currentTab === "Container" ? <AssociateContainerHistory setUpdated={setUpdated} previousPath={props.previousPath} associateLoginId={props.associateLoginId} startDate={props.startDate} endDate={props.endDate} /> :
                        currentTab === "Statistics" ? <IncidentReportView setUpdated={setUpdated} previousPath={props.previousPath} associateLoginId={props.associateLoginId} startTime={props.startDate} endTime={props.endDate} /> : null
                }
            </Column>
        </div>
    )
}





// WEBPACK FOOTER //
// ./src/components/detailPages/associateDetails/AssociateDetailsView.js